import React, { useState } from 'react';
import { TextInput } from '../../../components/TextInput';
import { TranslationKey } from '../../../../types/translation/TranslationKey';
import { t } from '../../../../types/translation/Translator';
import { Button, ButtonVariant } from '../../../components/Button/Button';
import { SignInScreenView } from '../SignInScreen';
import { AuthenticationRequest } from '../../../../requests/auth.request';
import { useRequest } from '../../../../requests/common/requestHook';
import { Divider } from '../../../components/Divider';
import { handleKeyEvent } from '../../../../util/events.util';

interface SignInCodeViewProps {
  email: string;
  password: string;
  setView: (view: SignInScreenView) => void;
}

export default function SignInCodeView({ email, password, setView }: SignInCodeViewProps) {
  const [code, setCode] = useState<string>('');

  const [login, { loading }] = useRequest(AuthenticationRequest.login);

  const VentoryAuthentication = async () => {
    const data = await login({ email, password, code });
  };

  return (
    <>
      <p className='my-2 text-center text-2xl font-bold'>{'Sign In'}</p>
      <div onKeyDown={async event => handleKeyEvent(event, 'Enter', VentoryAuthentication)}>
        <TextInput
          disabled={loading}
          value={code}
          label={t(TranslationKey.code).singular.label}
          placeholder={t(TranslationKey.code).singular.label}
          onChange={v => setCode(v)}
        />
      </div>
      <Button loading={loading} text={t(TranslationKey.signIn).singular.label} onClick={VentoryAuthentication} />
      <Button
        disabled={loading}
        variant={ButtonVariant.secondary}
        text={t(TranslationKey.back).singular.label}
        onClick={() => setView(SignInScreenView.credentials)}
      />
      <Divider />
    </>
  );
}
